import {lazy} from '@aboutyou/lazy-imports';
import {useLogHydrationFailed} from '@aboutyou/logic-components';
import React from 'react';
import {ArticleDetailSkeleton} from './ArticleDetailSkeleton';

const LoadingSkeletonWithHydrationFailedLogging: React.FC = () => {
  useLogHydrationFailed({context: 'ADPPageSkeleton'});
  return <ArticleDetailSkeleton />;
};

export const ArticleDetail = lazy(
  () =>
    import('./ArticleDetail.eager').then(mod => ({default: mod.ArticleDetail})),
  {
    fallback: <LoadingSkeletonWithHydrationFailedLogging />,
    aboveTheFold: true,
    isSsrAndNeedsHydration: true,
  },
);
